import React, { useState, ChangeEvent } from "react";
import LinearProgress from "@mui/material/LinearProgress";
import MuiPagination from "@mui/material/Pagination";
import { DataGrid } from "@mui/x-data-grid";

type props = {
  columns: any;
  rows: any;
  count?: number;
  page?: any;
  onPageChange?: any;
  loading?: any;
  getRowId?: (row: any) => any;
};

export default function TableComponent({
  rows,
  columns,
  count,
  page,
  onPageChange,
  loading,
  getRowId,
}: props) {
  const [searchValue, setSearchValue] = useState("");

  const handleSearch = (value: string) => {
    setSearchValue(value);
  };
  const Pagination = ({ page, onPageChange }: any) => {
    const totalPages = Math.ceil((count || 0) / 10);

    return (
      <MuiPagination
        color="primary"
        count={totalPages}
        page={page}
        disabled={rows?.length === 0}
        onChange={(event, newPage) => {
          onPageChange(event, newPage);
        }}
      />
    );
  };

  return (
    <DataGrid
      getRowId={getRowId || ((row) => row?._id || `${1}`)}
      slots={{
        pagination: () => (
          <Pagination onPageChange={onPageChange} page={page} />
        ),
        loadingOverlay: (props) => (
          <LinearProgress style={{ height: 4 }} {...props} />
        ),
      }}
      localeText={{
        noRowsLabel: "No data found",
      }}
      disableColumnSelector
      disableColumnMenu
      disableColumnFilter
      sortingMode="client"
      disableVirtualization={false}
      loading={loading}
      rows={rows}
      columns={columns}
      disableRowSelectionOnClick
      slotProps={{
        toolbar: {
          value: searchValue,
          clearSearch: () => handleSearch(""),
          onChange: (event: ChangeEvent<HTMLInputElement>) =>
            handleSearch(event.target.value),
        },
      }}
      sx={{
        ".MuiDataGrid-iconButtonContainer": {
          width: "auto",
          visibility: "visible",
        },
        ".MuiDataGrid-sortIcon": {
          display: "none",
        },
        ".MuiDataGrid-columnHeaderTitleContainer": { gap: 0 },
        ".MuiDataGrid-virtualScroller": {
          minHeight: "200px",
        },
      }}
      rowHeight={70}
    />
  );
}
